/**
 * API and authentication constants for the frontend application.
 */

// HTTP Headers
export const HTTP_HEADERS = {
  CONTENT_TYPE: 'Content-Type',
  AUTHORIZATION: 'Authorization',
} as const;

// Content Types
export const CONTENT_TYPES = {
  JSON: 'application/json',
  MULTIPART_FORM_DATA: 'multipart/form-data',
} as const;

// Authentication
export const AUTH = {
  BEARER_PREFIX: 'Bearer',
  SCOPES: {
    OPENID: 'openid',
    PROFILE: 'profile', 
    EMAIL: 'email',
    OFFLINE_ACCESS: 'offline_access', // Required for refresh tokens
    READ_DRAWS: 'read:draws',
    WRITE_DRAWS: 'write:draws',
  },
  get DEFAULT_SCOPES() {
    return `${this.SCOPES.OPENID} ${this.SCOPES.PROFILE} ${this.SCOPES.EMAIL} ${this.SCOPES.OFFLINE_ACCESS} ${this.SCOPES.READ_DRAWS} ${this.SCOPES.WRITE_DRAWS}`;
  }
} as const;

// HTTP Status Codes
export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  INTERNAL_SERVER_ERROR: 500,
} as const;